import styles from './Dashboard.less';

import React, { Component, PropTypes } from 'react';
import { connect } from 'react-redux';

import SignedInDashboard from 'SignedInDashboard/SignedInDashboard';
import SignedOutDashboard from 'SignedOutDashboard/SignedOutDashboard';
import { ScreenReaderOnly } from 'seek-style-guide/react';

@connect(({ user }) => ({
  authenticated: user.authenticated
}))
class Dashboard extends Component {

  static propTypes = {
    authenticated: PropTypes.bool.isRequired
  };

  render() {
    const { authenticated } = this.props;

    return (
      <section className={styles.root}>

        <ScreenReaderOnly>
          <h1>Dashboard</h1>
        </ScreenReaderOnly>

        {
          authenticated ?
            <SignedInDashboard /> :
            <SignedOutDashboard />
        }
      </section>
    );
  }

}

export default Dashboard;



/** WEBPACK FOOTER **
 ** ./app/components/HomePage/components/Dashboard/Dashboard.js
 **/